const ButtonGroup = {
  defaultProps: {
    disableElevation: true,
  },
};

export default ButtonGroup;
